import React, { useState, useEffect } from 'react';
import { Eye, EyeOff, Loader2 } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import { api } from '@/lib/api';
import { toast } from 'sonner';

const AdminSections = () => {
  const [sections, setSections] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toggling, setToggling] = useState(null);

  useEffect(() => {
    loadSections();
  }, []);

  const loadSections = async () => {
    try {
      const res = await api.getSections();
      setSections(res.data);
    } catch {
      toast.error('Error al cargar secciones');
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (key, currentVisible) => {
    setToggling(key);
    try {
      await api.toggleSection(key, !currentVisible);
      setSections(prev => ({
        ...prev,
        [key]: { ...prev[key], visible: !currentVisible },
      }));
      toast.success(`${sections[key].label_es} ${!currentVisible ? 'visible' : 'oculta'} al publico`);
    } catch {
      toast.error('Error al cambiar visibilidad');
    } finally {
      setToggling(null);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center gap-3 p-6">
        <Loader2 className="animate-spin text-gray-400" size={18} />
        <span className="text-sm text-gray-500">Cargando secciones...</span>
      </div>
    );
  }

  if (!sections) return null;

  return (
    <div className="space-y-3" data-testid="admin-sections">
      <p className="text-sm text-gray-500 mb-4">
        Controla que secciones son visibles para el publico. Las secciones ocultas solo son accesibles para administradores.
      </p>
      {Object.entries(sections).map(([key, section]) => (
        <div
          key={key}
          className={`flex items-center justify-between p-4 rounded-2xl border transition-colors ${
            section.visible
              ? 'bg-white border-gray-100'
              : 'bg-amber-50 border-amber-200'
          }`}
          data-testid={`section-toggle-${key}`}
        >
          <div className="flex items-center gap-3">
            {section.visible ? (
              <Eye className="text-[#006D77]" size={20} />
            ) : (
              <EyeOff className="text-amber-500" size={20} />
            )}
            <div>
              <span className="font-semibold text-sm text-[#1D1D1F]">{section.label_es}</span>
              {!section.visible && (
                <span className="ml-2 text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full">
                  Oculta
                </span>
              )}
            </div>
          </div>
          {toggling === key ? (
            <Loader2 className="animate-spin text-gray-400" size={18} />
          ) : (
            <Switch
              checked={section.visible}
              onCheckedChange={() => handleToggle(key, section.visible)}
              data-testid={`switch-${key}`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default AdminSections;
